//
// File: ShellIframeUrlHelpers.ts
// Description: Helper function for handling urls in the shell iframe plugins
// Copyright: Broadlume 2024
//

/**
 * Takes an initial url and a new href, returning the transformed url depending on
 * the format of the href
 * @remarks
 * If the href begins with a / it will replace the initial url with the href.
 * If the href begins with ../ we will remove the last segment of the url and replace it with the href, this will need to handle multiple ../
 * If the href begins with a # we will append the href to the url
 * If the href begins with anything else we will just append the href to the url
 * @param initialUrl - The initial url coming from the iframe
 * @param href - The href to transform
 * @returns The transformed url
 */
export const ShellIframeUrlHelper = (initialUrl: string, href: string): string => {
    if (href.startsWith('/')) {
        return href;
    }

    if (href.startsWith('../')) {
        const initialUrlSegments = initialUrl.split('/');
        const hrefSegments = href.split('/');
        const newUrlSegments = initialUrlSegments.slice(0, initialUrlSegments.length - hrefSegments.length + 1);
        return newUrlSegments.join('/') + '/' + hrefSegments.slice(1).join('/');
    }

    if (href.startsWith('#')) {
        return initialUrl + href;
    }

    return initialUrl + '/' + href;
};
